import { DateRange } from './DateFilterDropdown';

/**
 * Helper function to get date range for a preset value
 * This is used by QuickFilterButtons to calculate date ranges for presets
 */
export function getDateRangeForPreset(preset: string): DateRange {
  const now = new Date();
  const today = new Date(Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate()
  ));

  switch (preset) {
    case 'today':
      return { start: today, end: today };

    case 'yesterday': {
      const yesterday = new Date(today);
      yesterday.setUTCDate(today.getUTCDate() - 1);
      return { start: yesterday, end: yesterday };
    }

    case 'currentWeek': {
      const currentWeekStart = new Date(today);
      currentWeekStart.setUTCDate(today.getUTCDate() - today.getUTCDay());
      const currentWeekEnd = new Date(currentWeekStart);
      currentWeekEnd.setUTCDate(currentWeekStart.getUTCDate() + 6);
      return { start: currentWeekStart, end: currentWeekEnd };
    }

    case 'currentMonth': {
      const currentMonthStart = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 1));
      const currentMonthEnd = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() + 1, 0));
      return { start: currentMonthStart, end: currentMonthEnd };
    }

    case 'currentYear': {
      const currentYearStart = new Date(Date.UTC(today.getUTCFullYear(), 0, 1));
      const currentYearEnd = new Date(Date.UTC(today.getUTCFullYear(), 11, 31));
      return { start: currentYearStart, end: currentYearEnd };
    }

    case 'previousWeek': {
      const currentWeekStart = new Date(today);
      currentWeekStart.setUTCDate(today.getUTCDate() - today.getUTCDay());
      const previousWeekStart = new Date(currentWeekStart);
      previousWeekStart.setUTCDate(currentWeekStart.getUTCDate() - 7);
      const previousWeekEnd = new Date(currentWeekStart);
      previousWeekEnd.setUTCDate(currentWeekStart.getUTCDate() - 1);
      return { start: previousWeekStart, end: previousWeekEnd };
    }

    case 'previousMonth': {
      const previousMonthStart = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth() - 1, 1));
      const previousMonthEnd = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), 0));
      return { start: previousMonthStart, end: previousMonthEnd };
    }

    case 'previousYear': {
      const previousYearStart = new Date(Date.UTC(today.getUTCFullYear() - 1, 0, 1));
      const previousYearEnd = new Date(Date.UTC(today.getUTCFullYear() - 1, 11, 31));
      return { start: previousYearStart, end: previousYearEnd };
    }

    default:
      return { start: null, end: null };
  }
}
